<template>
  <header class="site-header">
    <div class="topbar">
      <div class="container">
        <div class="left">
          <span>{{$t('header_电话')}}：0591-22970811</span>
          <span class="divider">·</span>
          <span>{{$t('header_电子邮件')}}： <a href="mailto:sales@jdlpower.com">sales@jdlpower.com</a></span>
        </div>
        <div class="right">
<!--          <div class="search">-->
<!--            <input v-model="searchValue" type="text" :placeholder="$t('header_搜索placeholder')" @keyup.enter="onSearch" :aria-label="$t('header_搜索')"/>-->
<!--            <button class="search-btn" @click="onSearch">{{$t('header_搜索')}}</button>-->
<!--          </div>-->
          <div class="lang">
            <select v-model="innerLang" @change="emitLang">
              <option v-for="l in languages" :key="l.value" :value="l.value">{{ l.label }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="mainbar">
      <div class="container">
        <div class="logo" @click="$router.push('/')">
          <img :src="logoSrc" alt="GTL"/>
        </div>
        <nav class="menu">
          <div v-for="(item, idx) in menuItems" :key="item.path || ('mi-' + idx)" class="menu-item"
               @mouseenter="hoveredMenu = item.path"
               @mouseleave="hoveredMenu = null">
            <a :href="item.path" :class="{ active: isActive(item.path) }"
               @click.prevent="navigate(item.path)">{{ item.label }}</a>
            <div v-if="item.children && hoveredMenu === item.path" class="dropdown-menu">
              <a v-for="(child, cidx) in item.children" :key="(child.path || child.category || child.label) + '-' + cidx" :href="child.path"
                 @click.prevent="navigate(child.path)">{{ child.label }}</a>
            </div>
          </div>
          <button class="cta" @click.prevent="navigate('/contactus')">{{$t('header_获取报价')}}</button>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import i18n from "@/langurage";

export default {
  name: 'SiteHeader',
  props: {
    menuItems: {
      type: Array,
      default: () => []
    },
    languages: {
      type: Array,
      default: () => ([
        {label: '中文', value: 'zh'},
        {label: 'English', value: 'en'}
      ])
    },
    lang: {
      type: String,
      default: 'zh'
    },
    logoSrc: {
      type: String,
      default: () => require('@/assets/logo.png')
    }
  },
  data() {
    return {
      searchValue: '',
      innerLang: this.lang,
      hoveredMenu: null
    }
  },
  methods: {
    onSearch() {
      this.$emit('search', this.searchValue)
    },
    emitLang() {
      this.$i18n.locale = this.innerLang
      document.title = this.$t('品牌名')
	    console.log(this.$i18n.locale)
	    console.log(this.$t('username'))
      this.$emit('change-lang', this.innerLang)
    },
    navigate(path) {
      // 避免重复导航到当前路径
      if (this.$route && this.$route.path === path) return
      if (this.$router) {
        this.$router.push(path).catch(() => {})
      } else if (window.location.pathname !== path) {
        window.location.href = path
      }
    },
    isActive(path) {
      if (!this.$route) return false
      if (path === '/') return this.$route.path === '/'
      return this.$route.path.startsWith(path)
    }
  },
  watch: {
    lang(val) {
      this.innerLang = val
    }
  }
}
</script>

<style scoped>
.site-header {
  position: sticky;
  //position: fixed;
  top: 0;
  z-index: 100;
  background: #fff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.topbar {
  background: #225EAC;
  color: #fff;
  font-size: 12px;
}

.topbar .container {
  height: 36px;
}

.left a {
  color: #fff;
  text-decoration: none;
}

.left .divider {
  margin: 0 8px;
  opacity: .6;
}

.right {
  display: flex;
  gap: 12px;
  align-items: center;
}

.search {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, .12);
  border-radius: 4px;
  overflow: hidden;
}

.search input {
  color: #fff;
  background: transparent;
  border: 0;
  outline: 0;
  padding: 6px 8px;
  width: 200px;
}

.search input::placeholder {
  color: rgba(255, 255, 255, .7);
}

.search-btn {
  background: #225EAC;
  color: #fff;
  border: 0;
  padding: 6px 10px;
  cursor: pointer;
}

.lang select {
  background: #0f2142;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, .2);
  padding: 6px 8px;
  border-radius: 4px;
}

.mainbar {
  background: #fff;
  border-bottom: 1px solid #eef1f5;
}

.mainbar .container {
  height: 72px;
}

.logo img {
  height: 44px;
  cursor: pointer;
}

.menu {
  display: flex;
  align-items: center;
  gap: 20px;
}

.menu-item {
  position: relative;
}

.menu a {
  color: #2c3e50;
  text-decoration: none;
  font-weight: 600;
  padding-bottom: 6px;
  display: block;
}

.menu a.active {
  border-bottom: 3px solid #225EAC;
}

.menu a:hover {
  color: #225EAC;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-10px);
  background: #225EAC;
  border: 1px solid #225EAC;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  min-width: 170px;
  z-index: 1000;
  opacity: 0;
  transition: all 0.3s ease;
  pointer-events: none;
  padding: 10px 0;
}

.menu-item:hover .dropdown-menu {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
  pointer-events: auto;
}

.dropdown-menu a {
  display: block;
  padding: 18px 16px 18px 10px;
  color: #FFF;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.dropdown-menu a:last-child {
  border-bottom: none;
}

.dropdown-menu a:hover {
  background: #225EAC;
  color: #FFF;
  padding-left: 5px;
}

.menu .cta {
  margin-left: 8px;
  background: #225EAC;
  color: #fff;
  border: 0;
  padding: 8px 14px;
  border-radius: 20px;
  cursor: pointer;
}

@media (max-width: 1024px) {
  .search input {
    width: 140px;
  }
}

@media (max-width: 768px) {
  .mainbar .container {
    height: auto;
    padding: 10px 16px;
  }

  .container {
    flex-wrap: wrap;
  }

  .menu {
    width: 100%;
    justify-content: flex-end;
    flex-wrap: wrap;
    row-gap: 8px;
  }

  .dropdown-menu {
    position: static;
    opacity: 1;
    transform: none;
    box-shadow: none;
    border: none;
    background: #f8f9fa;
    margin-top: 8px;
    border-radius: 4px;
  }

  .menu-item:hover .dropdown-menu {
    opacity: 1;
    transform: none;
  }

  .dropdown-menu a {
    padding: 8px 12px;
    font-size: 14px;
  }
}
</style>
